import { render, staticRenderFns } from "./callbackForm.vue?vue&type=template&id=5a57f5f2&"
import script from "./callbackForm.vue?vue&type=script&lang=js&"
export * from "./callbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports